<template>
  <page
    v-if="loaded"
    :custom-style="{
      backgroundColor: '#fff',
      height: '100vh'
    }"
  >
    <!-- <head-nav :no-border="true">
      <span
        slot="left"
        class="back mc-app-normal mcicon-mc-icon-arrowleft1"
        @click="goBackPage"
      ></span>
      <p slot="title" class="head-title">选择订单</p>
    </head-nav> -->
    <page
      v-if="list.length > 0"
      :custom-style="{
        background: '#f5f5f5',
        bottom: 0,
        top: statusBarHeight
      }"
    >
      <div class="content">
        <p class="title">{{ tip }}</p>
        <ul class="select-list">
          <li
            v-for="item in list"
            :key="item.order_id"
            class="item"
            @click="goQuarantine(item)"
          >
            <div class="top">
              <span>订单号{{ item.order_id }}</span>
              <span>{{ item.c_t }}</span>
            </div>
            <div class="middle">
              <div class="text">{{ item.qc_text }}</div>
              <i class="arrow mcicon-mc_icon_arrowright"></i>
            </div>
          </li>
        </ul>
      </div>
    </page>
    <empty v-else :desc="tip" :img="'OrderList'" />
  </page>
</template>

<script>
import { API } from '@/api'
import Empty from '@/common/layout/empty'
// import appCommonInfo from 'app/utils/bridge/appCommonInfo.js'
// import blankImg from 'app/image/blank-page/default-quarantine.png'
// import { miniProgramEnv } from '@/defines/environment'
import { navBar } from '@/utils/native_interactions/native_bar'

// const appInfo = appCommonInfo.AppCommonInfo._ENV_.appInfo

const inspectTypeList = '0,1,2,3'
export default {
  components: {
    Empty
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '选择订单'
      })
    })
  },
  data() {
    return {
      list: [],
      show: false,
      tip: '',
      loaded: false
    }
  },
  computed: {
    // statusBarHeight: function () {
    //   return this.$cbridge.prepared && appInfo && appInfo.statusBarHeight
    //     ? // eslint-disable-next-line camelcase
    //       (appInfo.statusBarHeight + 44) / 50 + 'rem'
    //     : miniProgramEnv.isMiniProgram
    //     ? '0'
    //     : '.88rem'
    // }
  },
  created() {
    this.getQuarantineList()
  },
  methods: {
    goQuarantine(data) {
      this.$track(this.$trackMap.quarantine.btnChooseOrder)
      this.$router.push({
        name: 'quarantine',
        query: {
          c_t: data.c_t,
          id: data.order_id,
          inspectType: inspectTypeList
        }
      })
    },
    async getQuarantineList() {
      this.$Loading()
      const params = {
        inspectTypeList,
        newType: 1
      }
      try {
        const res = await API.quarantine.simpleListforqc(params)
        this.list = res.orderList || []
        this.tip = res.tips || ''
      } catch (error) {
        this.list = []
        this.tip = '当前30天内没有可以提供检疫证明的订单'
      }
      this.$Loading.hide()
      this.loaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .title {
    padding: 0.2rem 0 0.16rem 0.3rem;

    font-size: 0.24rem;
    color: #666666;
  }
  .select-list {
    .item {
      margin-bottom: 0.02rem;
      padding: 0.32rem 0.3rem;

      background: #fff;
      .top {
        margin-bottom: 0.3rem;
        span {
          font-size: 0.24rem;
          line-height: 0.32rem;
          color: #999999;
        }
      }
      .middle,
      .top {
        display: flex;

        justify-content: space-between;
      }
      .middle {
        align-items: center;
        .text {
          width: 6.5rem;

          font-size: 0.28rem;
          line-height: 0.32rem;
          color: #333333;
        }
        .arrow {
          color: #999999;
        }
      }
    }
  }
}
</style>
